/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
	ComposedModal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormGroup,
	TextInput,
	DropdownSkeleton,
	DataTableSkeleton,
	TableToolbar,
	Search,
	Button,
	DataTable,
	TableContainer,
	Table,
	TableBody,
	Pagination,
	DatePickerSkeleton,
	TableHead,
	TableHeader,
	TableRow,
	TableCell,
	Select,
	SelectItem,
	Form,
	FormLabel,
	FileUploader,
	Loading,
	Dropdown,
	InlineLoading
} from "carbon-components-react";
import Export16 from "@carbon/icons-react/lib/export/16";
import Edit16 from "@carbon/icons-react/lib/edit/16";
import Close20 from "@carbon/icons-react/lib/close/20";
import Import16 from "@carbon/icons-react/lib/download/16";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import Add16 from "@carbon/icons-react/lib/add/16";
import Search16 from "@carbon/icons-react/lib/search/16";
import Close16 from "@carbon/icons-react/lib/close/16";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import { v4 as uuid } from "uuid";
import Data16 from "@carbon/icons-react/lib/data--1/16";
import { hoccard, me, api, registry, dynamic } from "../../helpers/api/api";
import { ConfirmAlertCustom } from "../../helpers/ConfirmAlertCustom";
import { getSuccess, getError, entitiesLabels, apioperation, DateFormat } from "../../helpers/Constants";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { ComboBox } from "../../helpers/ComboBox";
import { FindGHRSEmployer } from "../common/FindGHRSEmployer";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import { RenderDataTableCell, NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import { IsInRole, IsEditable, CanExecuteAction } from "../../helpers/authorization/Policies";
import { AppContext } from "../../helpers/context/AppContext";
import DateTimePicker from "../../helpers/DateTimePicker";
import { Online, Offline } from "../common/OnLineOffLine";
import FileDownLoadButton from "../common/FileDownloadButton";
import HocCardRepository from "../../helpers/api/HocCardRepository";
import FindSaipemCompilers from "../common/FindSaipemCompilers";

export class HocCard extends Component {
  // static combo option lists
    completionStatusList = ['All', 'Not Reviewed', 'Reviewed'];

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.validatorworksite = new SimpleReactValidator();
    this.year = new Date().getFullYear();
    this.state = {
      // utilizzato per  update

      isEditModal: false,
      isLoadingList: true,
      idToDelete: null,
      isOpenDeleteModal: false,
      isDeleting: null,
      isImportHC: false,
      isImportHoc: false,
      // //EMPLOYER
      mode: 0,
      selectEmployer: null,
      selectEmployer2: null,
      // SPINNER
      isSubmitted: false,
      isExportfunction: false,
      isImportfunction: false,
      hocHandledByMe: [],
      hocCarAssignedToMe: [],
      message: [],
      hoctype: [],
      lifesavingrule: [],
      hazardtype: [],
      hocpriority: [],
      status: null,
      infooriginator: [],
      worksites: [],
      worksite: [],
      project: null,
      allProject: [],
      isLoadingWorksite: false,
      isLoadingModules: false,
      isOpenModalExportTemplate: false,
      isOpenFilterHoc: false,
      isOpneNewHoc: false,

      // /loading skeleton
      isLoadingProject: true,
      isLoadingHazardType: true,
      isLoadingHocType: true,
      // isLoadingStatus: true,
      isLoadingInfoOriginator: true,
      isLoadingHocPriprity: true,
      isLoadingLifeSavingRule: true,
      isLoadingDate: true,
      isLoadingElement: true,

      isStatus: ['All', 'N/A', 'Opened', 'Closed'],
      xCar: ['All', 'Yes', 'No'],
      hocHandledByMeOptions: ['Me', 'Other Compilers', 'All Compilers'],
      hocCarAssignedToMeOptions: ['Me', 'Other Compilers', 'All'],

      carValidator: false,

      currentPage: 1,
      pageSize: 300, //RITM1110820 - HOC Slowness Issue
      itemList: [],

      importDanger: false,
      searchModel: {
        ...this.searchProp(),
      },

      hocCardModel: {
        ...this.hoCardProps(),
      },

      hocCardSources: [],

      isBack: this.props.history.action === 'POP' || this.props.location.search === '?isBack',
      yearsList: [],
      filteredYear: null
    };
    this.validator = new SimpleReactValidator();
    this.getHocCard = this.getHocCard.bind(this);
    this.getUserWorksite = this.getUserWorksite.bind(this);
    this.downloadHocTemplate = this.downloadHocTemplate.bind(this);
    this.uploadHocTemplate = this.uploadHocTemplate.bind(this);
    this.toggleModalExportTemplate = this.toggleModalExportTemplate.bind(this);
    this.toggleModalUploadTemplate = this.toggleModalUploadTemplate.bind(this);
    this.handleChangeWorksite = this.handleChangeWorksite.bind(this);
    this.showDivFilter = this.showDivFilter.bind(this);
    this.showNewHocCard = this.showNewHocCard.bind(this);
    this.showEditModal = this.showEditModal.bind(this);
    this.handleChangeComboWorksite = this.handleChangeComboWorksite.bind(this);
    this.refreshData = this.refreshData.bind(this);
  }

  componentDidMount() {
    console.log('component did mount');
    this.getHocCardsYears();
    this.refreshData();
  }

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  getHashtag = () => {
    if (this.props.location?.hash != null && this.props.location.hash.length > 1) {
      return decodeURIComponent(this.props.location.hash.substring(1));
    }
    return null;
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      this.setState((prevState) => { 
        const statusCopy = { ...prevState.hocCardModel };
        if (statusCopy.hocCardCAR == null) {
            statusCopy.hocCardCAR = {};
        }
        statusCopy.hocCardCAR.idEmployer = employer.id;
        statusCopy.hocCardCAR.nameEmployer = employer.name;
        statusCopy.hocCardCAR.owner = employer;
        statusCopy.hocCardCAR.idOwnerSaipem = null;
        statusCopy.hocCardCAR.ownerSaipem = null;
        return { hocCardModel: statusCopy, mode: 0 }; 
        });
      this.setState({ selectEmployer: employer });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      this.setState((prevState) => {
        const statusCopy = { ...prevState.hocCardModel };
        if (statusCopy.hocCardCAR == null) {
          statusCopy.hocCardCAR = {};
        }
        statusCopy.hocCardCAR.idOwnerSaipem = employer.id;
        statusCopy.hocCardCAR.nameEmployer = employer.name;
        statusCopy.hocCardCAR.ownerSaipem = employer;
        statusCopy.hocCardCAR.idEmployer = null;
        statusCopy.hocCardCAR.owner = null;
        return { hocCardModel: statusCopy, mode: 0 };
      });
      this.setState({ selectEmployer: employer });
    }
  };

  async getProjectbyWorkSite(idWorkSite) {
    try {
      const list = await HocCardRepository.getWorkSiteProject();
      const projects = list.filter((res) => res.idWorkSite === idWorkSite)
                            .map((ele) => ({ id: ele.idProject, name: ele.project }));
      this.setState({
        project: projects,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
    }
  }

  hoCardProps = () => ({
    idProject: null,
    idHocType: null,
    idHazardType: null,
    idHocPriority: null,
    idLifeSavingRule: null,
    idInfoOriginator: null,
    // idStatus: null,
    status: null,
    immediateActions: null,
    comments: null,
    description: null,
    location: null,
    occurredAt: null,
    additionalInfo: null,
    userReportedBy: null,
    idHocCardCar: null,
    idWorkSite: null,
    idCompiler: null,
    code: null,
    localId: null,
    hocCardCAR: {
      // carModel
      id: null,
      dueDate: null,
      description: null,
      idEmployer: null,
      idOwnerSaipem: null,
      owner: null, // {}
      ownerSaipem: null,
    },
    nameEmp: '',
  });

  searchProp = () => ({
    idProject: null,
    idHazardType: null,
    idHocType: null,
    idWorkSite: null,
    idInfoOriginator: null,
    status: null,
    xCar: null,
    code: this.getHashtag(),
    localId: null,
    hocHandledByMe: null,
    hocCarAssignedToMe: null,
    idHocCardSource: null,
    completionStatus: null,
    year: null
  });

  clearTemplate = () => {
    this.setState({
      worksite: {},
      isOpenModalExportTemplate: false,
    });

    this.forceUpdate();
    this.validatorworksite = new SimpleReactValidator();
  };

  clearInsertForm = () => {
    this.setState({
      hocCardModel: {
        ...this.hoCardProps(),
      },
      selectEmployer: null,
    });
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.isBack = false;

    this.setState(statusCopy);
  };

  updateStateCAR = (inputName, inputValue, objName) => {
    this.setState((prevState) => {
        const statusCopy = { ...prevState.hocCardModel };
        if (statusCopy.hocCardCAR == null) {
            statusCopy.hocCardCAR = {};
        }
        statusCopy[objName][inputName] = inputValue;
        return { hocCardModel: statusCopy };
    });
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;

    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    // statusCopy['selectedItemCombo'][inputName] = selectedItem;
    statusCopy.isBack = false;

    this.setState(statusCopy);
    // console.log(statusCopy);
  };

  handleChangeComboStatusModel = (selectedItem, objName) => {
    if (objName !== 'All') {
        if (objName === 'Closed') {
            (this.state.hocCardModel.status = 'Closed');
        } else {
            (this.state.hocCardModel.status = 'Opened');
        }
    } else {
        (this.state.hocCardModel.status = null);
    } 

    const statusCopy = { ...this.state.hocCardModel };
    statusCopy.status = objName;
    // statusCopy['selectedItemCombo'][inputName] = selectedItem;
    this.setState(statusCopy);

    this.setState({ IsStatus: ['Opened ', 'Closed', 'All'] });
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'hocCardModel');
  };

  handleChangeComboBool = (inputName, selectedItem,) => {
    const val = selectedItem !== 'All' ? selectedItem !== 'No' : null;
    this.setState((prevState) => {
        const statusCopy = { ...prevState.searchModel };
        statusCopy.xCar = val;
        return { searchModel: statusCopy, isBack: false };
    });
  };

  handleChangeHocCardSourceFilter = (_, selectedItem) => {
    const inputValue = (selectedItem && selectedItem.id) || null;
    this.setState((prevState) => {
        const stateCopy = { ...prevState.searchModel };
        stateCopy.idHocCardSource = inputValue;
        return { searchModel: stateCopy, isBack: false };
      }); 
  };

  handleChangeCompletionStatusFilter = (inputName, selectedItem,) => {
    // RITM0544922
    const stateCopy = { ...this.state };
    stateCopy.searchModel.completionStatus = selectedItem !== 'All' ? selectedItem : null;
    stateCopy.isBack = false;
    this.setState(stateCopy);
  };

  handleChangeComboOwner = (inputName, selectedItem,) => {
    const val = selectedItem !== 'All Compilers' && selectedItem != null ? selectedItem !== 'Other Compilers' : null;
    this.setState((prevState) => {
        const statusCopy = { ...prevState.searchModel };
        statusCopy.hocHandledByMe = val;
        return { searchModel: statusCopy, isBack: false };
      });
  };

  handleChangeComboCarOwner = (inputName, selectedItem,) => {
    const val = selectedItem !== 'All' && selectedItem != null ? selectedItem !== 'Other Compilers' : null;
    this.setState((prevState) => {
        const statusCopy = { ...prevState.searchModel };
        statusCopy.hocCarAssignedToMe = val;
        return { searchModel: statusCopy, isBack: false };
      });
  };

  handleChangeComboStatus = (inputName, selectedItem,) => {
    // RITM0544922
    const stateCopy = { ...this.state };
    stateCopy.searchModel.status = selectedItem !== 'All' ? selectedItem : null;
    stateCopy.isBack = false;
    this.setState(stateCopy);
  };

  handleChangeSearch = (el) => {
    const inputName = el.target.name;

    const inputValue = el.target.value;

    this.updateState(inputName, inputValue, 'searchModel');
  };

  handleChangeComboWorksite = (inputName, selectedItem, objName) => {
    //console.log(selectedItem);

    const inputValue = selectedItem ? selectedItem.id : null;
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.project = null;
    statusCopy.hocCardModel.idProject = null;

    this.setState(statusCopy, () => {
      if (inputValue) {
        this.getProjectbyWorkSite(inputValue);
      }
    });
  };

  handleChangeComboSearchWorkSite = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;

    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    // statusCopy['selectedItemCombo'][inputName] = selectedItem;
    statusCopy.isBack = false;
    this.setState(statusCopy);
  };

  updateStateDP = (inputName, inputValue, objName) => {
    this.setState(
      (prevState) => ({
        [objName]: {
          ...prevState[objName],
          [inputName]: inputValue,
        },
      }),
      () => {
        this.hoCardProps(inputName, inputValue);
      }
    );
  };

  updateStateDPCAR = (inputName, inputValue, objName) => {
    this.setState((prevState) => { 
        const statusCopy = { ...prevState.hocCardModel };
        if (statusCopy.hocCardCAR == null) {
            statusCopy.hocCardCAR = {};
        }
        statusCopy[objName][inputName] = inputValue;
        return { hocCardModel: statusCopy };
     });
      
    this.setState(
      (prevState) => ({
        [objName]: {
          ...prevState[objName],
          [inputName]: inputValue,
        },
      }),
      () => {
        this.hoCardProps(objName, inputValue);
      }
    );
  };

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  handleChangeModelCar = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;

    this.updateStateCAR(inputName, inputValue, 'hocCardCAR');
  };

  handleChangeWorksite = (el) => {
    const inputValue = el.target.value;
    this.setState({
      worksite: { id: inputValue },
    });
  };

  // /////GET Props
  getUserWorksite = () => {
    this.setState({
      isLoadingWorksite: true,
    });
    me.getAll('worksites')
      .then((response) => {
        this.setState({
          worksites: response.data,
          isLoadingWorksite: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
      });
  };

  getHocType = () => {
    dynamic
      .getAll('hoctype', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          hoctype: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCTYPE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingHocType: false,
        });
      });
  };

  getHazardType = () => {
    dynamic
      .getAll('hazardtype', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList.filter((a) => moment(a.validUntil).isSameOrAfter(moment())); //RITM1015981
        this.setState({
          hazardtype: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HAZARDTYPE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingHazardType: false,
        });
      });
  };

  getHocPriority = () => {
    dynamic
      .getAll('hocpriority', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          hocpriority: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCPRIORITY, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingHocPriprity: false,
        });
      });
  };

  getLSR = () => {
    dynamic
      .getAll('lifesavingrule', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          lifesavingrule: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.LIFESAVINGRULEVIOLATION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingLifeSavingRule: false,
        });
      });
  };

  getInfoOriginator = () => {
    registry
      .getAll('infooriginator')
      .then((response) => {
        const { data } = response;
        this.setState({
          infooriginator: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingInfoOriginator: false,
        });
      });
  };

  getAllProject = () => {
    this.setState({
      isLoadingProject: true,
    });
    me.getAll('project')
      .then((response) => {
        this.setState({
          allProject: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingProject: false,
        });
      });
  };

  getHocCardSources = () => {
    this.setState({ isLoadingHocCardSources: true });
    hoccard.sources
      .getAll()
      .then((response) => {
        this.setState({ hocCardSources: response.data });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDSOURCES, apioperation.GET));
      })
      .finally(() => {
        this.setState({ isLoadingHocCardSources: false });
      });
  };

  getHocCardsYears = () => {
    hoccard.years
      .getAll()
      .then((response) => {
        this.setState({ yearsList: response.data });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDSAVAILABLEYEARS, apioperation.GET));
      });
  }

  onYearChange = (selectedItem) => {
    let year;
    try {
      year = selectedItem.selectedItem;
    } catch (error) {
      year = this.year;
    }
    this.setState({ filteredYear: year, isBack: false }, () => {
      this.refreshData();
    });
  }

	// ////DOWNLOAD
	toggleModalExportTemplate = (open) => {
		this.setState({ isOpenModalExportTemplate: open });
	}

	
	getTemplateExcelForEdit = async () => {
		this.setState({ isExportfunction: true })
		let data;
		if (!this.state.isBack) {
			data = {
				params: {
					...this.state.searchModel,
				},
			};
		} else {
			let filter = await HocCardRepository.getBackPaged();
			if(filter === undefined) {
				data = {
					params: {
						...this.state.searchModel,
					},
				};
				data.params.page =null;
				data.params.pageSize = null;
			}
			else{
				data = { params: filter.params };
				data.params.page = null; 
				data.params.pageSize = null; 
			}
		}
		data.params.year = this.state.filteredYear ? this.state.filteredYear : this.year;
    //RITM0958798 - HOC Download Fix
		//hoccard.downloadEditTemplate(data)
		//.then((response) => {
		//	const link = document.createElement('a');
		//	const data = new Blob([response.data], {
		//		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		//	});
		//	const url = window.URL.createObjectURL(data);
		//	link.setAttribute('href', url);
		//	link.setAttribute('download', "HocCardTemplate.xlsx");
		//	link.style.visibility = 'hidden';
		//	document.body.appendChild(link);
		//	link.click();
		//	document.body.removeChild(link);
		//})
    hoccard.downloadEditTemplate(data)
    .then((response) => {
			const link = document.createElement('a');
      const url = window.URL.createObjectURL(new Blob([response.data]));
      link.href =url
      link.setAttribute('download', "HocCardTemplate.xlsx");
      document.body.appendChild(link);
			link.click();
      window.URL.revokeObjectURL(url);
    })
    //End
		.catch((error) => {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.DOWNLOAD));
		})
		.finally(() => {
			this.setState({ isExportfunction: false })
		});
	};

	toggleModalUploadTemplate = (open) => {
		this.fileUploader.clearFiles();
		this.setState({
			isOpenModalUploadTemplate: open,
			isImportHC: true,
			message: [],
			statusUpload: null,
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
			__filename: null,
		});
	};
	toggleModalUploadEditTemplate = (open) => {
		this.fileUploader.clearFiles();
		this.setState({
			isOpenModalUploadEditTemplate: open,
			isImportEditHC: true,
			message: [],
			statusUpload: null,
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
			__filename: null,
		})
	}
	uploadHocTemplate = (event) => {
		if (this.state.statusUpload != null) {
			this.setState({
				isImportfunction: true,
				isImportHoc: true,
				message: [],
			});
			event.preventDefault();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				statusUpload: "uploading",
				// isImportHoc: true,
			}));
			const formData = new FormData();
			formData.append("FileUploaded", event.target.inputFile.files[0]);
			// console.log(formData);

      hoccard
        .uploadTemplate(formData, this.state.worksite.id)
        .then((response) => {
          this.setState(() => ({
            canUpload: false,
            isFileValid: true,
            validationErrorTitle: '',
            validationErrorSubTitle: '',
            statusUpload: 'complete',
            message: response.data,

            isImportHoc: false,
            isImportfunction: false,
          }));

          if (this.state.message[0] === 'Success') {
            this.getHocCard({ page: 1 });
            showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.HOCCARDTEMPLATE, apioperation.UPLOAD));
            this.setState(() => ({
              isOpenModalUploadTemplate: false,
            }));
          }
        })
        .catch((error) => {
          this.setState(() => ({
            canUpload: true,
            isFileValid: false,

            statusUpload: 'edit',
            isImportHoc: false,
            isImportfunction: false,
            importDanger: true,
          }));
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.UPLOAD));
        });
    }
  };


	uploadHocEditTemplate = (event) => {
		if (this.state.statusUpload != null) {
			this.setState({
				isImportEditfunction: true,
				isImportEditHoc: true,
				message: [],
			});
			event.preventDefault();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				statusUpload: "uploading",
				// isImportHoc: true,
			}));
			const formData = new FormData();
			formData.append("FileUploaded", event.target.inputFile.files[0]);
			// console.log(formData);

			hoccard
				.uploadEditTemplate(formData)
				.then((response) => {
					this.setState(() => ({
						canUpload: false,
						isFileValid: true,
						validationErrorTitle: "",
						validationErrorSubTitle: "",
						statusUpload: "complete",
						message: response.data,

						isImportEditHoc: false,
						isImportEditfunction: false,
					}));

					if (this.state.message[0] == "Success") {
						this.getHocCard({ page: 1 });
						showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.HOCCARDTEMPLATE, apioperation.UPLOAD));
						this.setState(() => ({
							isOpenModalUploadTemplate: false,
						}));
					}
				})
				.catch((error) => {
					this.setState(() => ({
						canUpload: true,
						isFileValid: false,

						statusUpload: "edit",
						isImportHoc: false,
						isImportEditfunction: false,
						importDanger: true,
					}));
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.UPLOAD));
				});
		}
	};

	// //
	downloadHocTemplate() {
		if (this.validatorworksite.allValid()) {
			this.setState({
				isExportfunction: true,
			});
			if (this.validatorworksite.allValid()) {
				hoccard
					.downloadTemplate(this.state.worksite.id, { responseType: "arraybuffer" })
					.then((response) => {
						const data = new Blob([response.data], {
							type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						});
						const csvURL = window.URL.createObjectURL(data);
						const tempLink = document.createElement("a");
						tempLink.href = csvURL;
						const nomefile = "HocCardTemplate.xlsx";
						tempLink.setAttribute("download", nomefile);
						document.body.appendChild(tempLink);
						tempLink.click();
						this.toggleModalExportTemplate(false);
					})
					.catch((error) => {
						showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.DOWNLOAD));
					})
					.finally(() => {
						this.setState({
							isExportfunction: false,
						});
					});
			} else {
				this.validatorworksite.showMessages();
				this.forceUpdate();
			}
		} else {
			this.validatorworksite.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, ` ${entitiesLabels.WORKSITE} required fields are missing  `);

			this.forceUpdate();
		}
	}

	// ////CREATE/UPDATE  NEW HOC
	handleSubmitInsert = () => {
		if (this.validator.allValid()) {
			this.setState({
				isSubmitted: true,
			});

      const datiForm = this.state.hocCardModel;
      datiForm.id = this.state.hocCardModel.id || uuid();
      if (datiForm.hocCardCAR != null) {
        if ((datiForm.hocCardCAR.description != null && datiForm.hocCardCAR.description !== '') || datiForm.hocCardCAR.dueDate != null || datiForm.hocCardCAR.idEmployer != null) {
          // controllo che i due cambi siano diversi da null per creare/modficare una car

          // inserimento
          const newid = uuid();
          datiForm.idHocCardCar = newid;
          datiForm.hocCardCAR.id = newid;
        } else if ((datiForm.hocCardCAR.description == null || datiForm.hocCardCAR.description === '') && datiForm.hocCardCAR.dueDate == null && datiForm.hocCardCAR.idEmployer == null) {
          // per inserimento e modifica imposta la car a null i campi della car sono  null
          datiForm.idHocCardCar = null;
          datiForm.hocCardCAR = null;
        } else {
          // mostra messaggio errore e non effettua modifiche
          showNotification.error(`${entitiesLabels.ERROR}`, 'hocCardCAR');
          return;
        }
      }

      const method = this.state.isEditModal ? hoccard.put(datiForm, this.state.hocCardModel.id) :
                                              hoccard.post(datiForm);

      method
        .then(async (response) => {
          if (response.status === 200) {
            const dataList = {
              id: datiForm.id,
              description: datiForm.description,
              project: this.state.project && this.state.hocCardModel.idProject ?
               this.state.project.find(
                (el) => el.id === this.state.hocCardModel.idProject).name : null,
              hazardType: (this.state.hazardtype || [])
               .find((el) => el.id === this.state.hocCardModel.idHazardType).name,
              infoOriginator: (this.state.infooriginator || [])
               .find((el) => el.id === this.state.hocCardModel.idInfoOriginator).name,
              reportBy: datiForm.reportBy,
              hocType: (this.state.hoctype || [])
               .find((el) => el.id === this.state.hocCardModel.idHocType).name,
              status: datiForm.status || datiForm.idHocCardCar != null ? 'Opened' : 'Closed',
              occurredAt: datiForm.occurredAt,
              isCar: datiForm.idHocCardCar != null,
            };
            await HocCardRepository.updateCachedList(this.state.currentPage, 
                                                     this.state.pageSize, dataList);
            await HocCardRepository.updateCachedDetail(datiForm);
            showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.HOCCARD, this.state.isEditModal ? apioperation.PUT : apioperation.POST));
            this.getHocCard({ page: 1 });
            this.clearInsertForm();
            this.setState({
              // isOpneNewHoc: true,
              isEditModal: false,
              isOpneNewHoc: false,
            });
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARD, this.state.isEditModal ? apioperation.PUT : apioperation.POST));
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
          });
        });
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, `${entitiesLabels.HOCCARD} required fields are missing  `);
      this.forceUpdate();
    }
  };

  deleteEmployer = () => {
    this.setState((prevState) => {
        const statusCopy = { ...prevState.hocCardModel };
        statusCopy.hocCardCAR.owner = null;
        statusCopy.hocCardCAR.idEmployer = null;
        statusCopy.hocCardCAR.idOwnerSaipem = null;
        statusCopy.hocCardCAR.ownerSaipem = null;
        return { hocCardModel: statusCopy };
    });
  };

  clearFiles = () => {
    this.fileUploader.clearFiles();
    this.setState(() => ({
      canUpload: false,
      isFileValid: true,
      validationErrorTitle: '',
      validationErrorSubTitle: '',
    }));
  };

  clearFilter = () => {
    this.setState((oldState) => ({ isOpenFilterHoc: !oldState.isOpenFilterHoc }));
    this.setState(
      {
        searchModel: {
          ...this.searchProp(),
        },
        isBack: false,
      },
      () => {
        this.getHocCard({ page: 1 });
      }
    );
  };

  onFileUploadChange = (evt) => {
    this.setState(() => ({ statusUpload: 'edit' }));
    if (evt.target.files[0] && evt.target.files[0].size >= 4194304) {
      const nome = evt.target.files[0].name;
      this.fileUploader.clearFiles();
      this.setState(() => ({
        canUpload: false,
        message: [],
        isFileValid: false,
        isImportHoc: false,
        validationErrorTitle: `${nome} exceeds size limit`,
        validationErrorSubTitle: '4mb max file size. Please select a new file and try again',
      }));
    } else {
      // this.fileUploader.clearFiles();
      this.setState(() => ({
        canUpload: true,
        isFileValid: true,
        validationErrorTitle: '',
        validationErrorSubTitle: '',
        message: [],
      }));
    }
  };

  // ///DELETE HOC CARD

  deleteItem = () => {
    const id = this.state.idToDelete;
    this.setState({
      isDeleting: true,
    });
    hoccard
      .delete(id)
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseConfirm();
          this.getHocCard();
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.HOCCARD, apioperation.DELETE));
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARD, apioperation.DELETE));
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };

  confirmDelete = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  // //Filter HOC CARD

	getHocCard = async (param) => {
		this.setState({
			isLoadingList: true,
			isLoadingDate: true,
			isLoadingElement: true,
		});
		let data;
		if (!this.state.isBack) {
			data = {
				params: {
					...this.state.searchModel,
				},
			};
			data.params.page = param && param.page ? param.page : this.state.currentPage;
			data.params.pageSize = param && param.pageSize ? param.pageSize : this.state.pageSize;
			//RITM0549692
		} else {
			let filter = await HocCardRepository.getBackPaged();
			// If navigating back with at least one non-trivial filter applied, open filter panel
			if(filter === undefined) {
				data = {
					params: {
						...this.state.searchModel,
					},
				};
				data.params.page = param && param.page ? param.page : this.state.currentPage;
				data.params.pageSize = param && param.pageSize ? param.pageSize : this.state.pageSize;
			}
			else{
				let isOpenFilterHoc = Object.keys(filter.params).some((p) => p !== "page" && p !== "pageSize" && filter.params[p] != null);
				data = { params: filter.params };
				data.params.page = 1; //RITM0549692
				this.setState({ searchModel: filter?.params, isOpenFilterHoc });
			}
		}
		//console.log("YEAR HOC CARD Year: "+this.year)
		//console.log("YEAR HOC CARD FilteredYear: "+this.state.filteredYear)
		data.params.year = this.state.filteredYear ? this.state.filteredYear : this.year;
		//console.log("params year : "+ data.params.year)
		hoccard
		.getWithParamYear(data,this.year)
		.then((response) => {
			this.setState({
				...response.data,
			});
			if (response.status == 200) {
				this.setState({
					isLoadingList: false,
					isLoadingElement: false,
					currentPage: data.params.page, //RITM0549692
				});
			}
			if (!this.state.isBack) {
				HocCardRepository.updateHocCardFilter(data);
			}
		})
		.catch((error) => {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARD, apioperation.GET));
		})
		.finally(() => {
			this.setState({
				isLoadingList: false,
				isLoadingDate: false,
				isLoadingElement: false,
			});
		});
	};

  handleClickSearch = (e) => {
    e.preventDefault();
    this.getHocCard({ page: 1 });
  };

  handleChangePaging = (event) => {
    this.setState({ isBack: false }, () => this.getHocCard(event));
  };

  refreshData() {
    this.getHocCard();
    this.getUserWorksite();
    this.getHocType();
    this.getHazardType();
    this.getHocPriority();
    this.getLSR();

    this.getInfoOriginator();
    this.getAllProject();
    // this.getHocCardList();
    this.getHocCardSources();
  }

  showEditModal() {
    this.clearInsertForm();
    this.setState((oldState) => ({ isEditModal: !oldState.isEditModal }));
  }

  showDivFilter() {
    this.setState((oldState) => ({ isOpenFilterHoc: !oldState.isOpenFilterHoc }));
    this.clearFiles();
  }

  showNewHocCard() {
    this.props.history.push('/hoccard/new');
  }

    // //DIV NEW E  UPDATE
    divMessaggImportHC() {
        return (
          <div>
            {!this.state.isImportHoc ? '' : <Loading />}
    
            {this.state.message[0] === 'Success' ? (
              <div />
            ) : (
              <div>
                {this.state.message.map((x) => (
                  <div className="bx--row">
                    <div className="srv-validation-message"> 
                      {' '}
                      {x}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      }

    // //
    downloadHocTemplate() {
        if (this.validatorworksite.allValid()) {
          this.setState({
            isExportfunction: true,
          });
          if (this.validatorworksite.allValid()) {
            hoccard
              .downloadTemplate(this.state.worksite.id, { responseType: 'arraybuffer' })
              .then((response) => {
                const data = new Blob([response.data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const csvURL = window.URL.createObjectURL(data);
                const tempLink = document.createElement('a');
                tempLink.href = csvURL;
                const nomefile = 'HocCardTemplate.xlsx';
                tempLink.setAttribute('download', nomefile);
                document.body.appendChild(tempLink);
                tempLink.click();
                this.toggleModalExportTemplate(false);
              })
              .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.DOWNLOAD));
              })
              .finally(() => {
                this.setState({
                  isExportfunction: false,
                });
              });
          } else {
            this.validatorworksite.showMessages();
            this.forceUpdate();
          }
        } else {
          this.validatorworksite.showMessages();
          showNotification.warning(`${entitiesLabels.WARNING}`, ` ${entitiesLabels.WORKSITE} required fields are missing  `);
    
          this.forceUpdate();
        }
      }

      divFiterHocCard() {
        /*
        const isCar = {
          IsCar: true,
          NotCar: false,
          AllCar: null,
        };
        */
        let xCarValue = '';
        if (this.state.searchModel.xCar == null) xCarValue = 'All';
        else if (this.state.searchModel.xCar === false) { xCarValue = 'No'; } else { xCarValue = 'Yes'; }

        let statusValue = '';
        if (this.state.searchModel.status == null) statusValue = 'All';
        else if (this.state.searchModel.status === false) { statusValue = 'Closed'; } else { statusValue = 'Opened'; }

        let hocHandledByMeValue = '';
        if (this.state.searchModel.hocHandledByMe == null) hocHandledByMeValue = 'All Compilers';
        else if (this.state.searchModel.hocHandledByMe === false) { hocHandledByMeValue = 'Other Compilers'; } else { hocHandledByMeValue = 'Me'; }

        let hocCarAssignedToMeValue = '';
        if (this.state.searchModel.hocCarAssignedToMe == null) hocCarAssignedToMeValue = 'All';
        else if (this.state.searchModel.hocCarAssignedToMe === false) { hocCarAssignedToMeValue = 'Other Compilers'; } else { hocCarAssignedToMeValue = 'Me'; }

        const filterItems = {
          idProject: this.state.searchModel?.idProject ? (this.state.allProject || [])
              .find((el) => el.id === this.state.searchModel.idProject) : [],
          idHazardType: this.state.searchModel?.idHazardType ? (this.state.hazardtype || [])
              .find((el) => el.id === this.state.searchModel.idHazardType) : [],
          idHocType: this.state.searchModel?.idHocType ? (this.state.hoctype || [])
              .find((el) => el.id === this.state.searchModel.idHocType) : [],
          idWorkSite: this.state.searchModel?.idWorkSite ? (this.state.worksites || [])
              .find((el) => el.id === this.state.searchModel.idWorkSite) : [],
          xCar: xCarValue,
          status: statusValue,
          idInfoOriginator: this.state.searchModel.idInfoOriginator ? 
              (this.state.infooriginator || [])
                  .find((el) => el.id === this.state.searchModel.idInfoOriginator) : null,
    
          // isStatus:null
          hocHandledByMe: hocHandledByMeValue,
          hocCarAssignedToMe: hocCarAssignedToMeValue,
          idHocCardSource: this.state.searchModel?.idHocCardSource ? 
              (this.state.hocCardSources || [])
                  .find((el) => el.id === this.state.searchModel.idHocCardSource) : [],
          completionStatus: this.state.searchModel.completionStatus || 'All',
        };
    
        return (
          <div style={{ display: this.state.isOpenFilterHoc ? 'block' : 'none' }}>
            {' '}
            {/* inserire nel form */}
            <div className="bx--row">
              <FormGroup legendText="" className="bx--col-md-4">
                <FormLabel className="some-class">Worksite</FormLabel>
    
                {this.state.isLoadingWorksite ? (
                  <DropdownSkeleton />
                ) : (
                  <ComboBox
                    id="idSearchWorkSite"
                    placeholder={this.state.searchModel.idWorkSite ? filterItems.idWorkSite : 'All'}
                    key="srcxCar"
                    name="idWorkSite"
                    alt="searchModel"
                    onChange={this.handleChangeComboSearchWorkSite}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={this.state.searchModel.idWorkSite ? filterItems.idWorkSite : 'All'}
                    items={this.state.worksites}
                  />
                )}
              </FormGroup>
    
              <FormGroup legendText="" className="bx--col-md-4">
                <FormLabel className="some-class">Project</FormLabel>
                {this.state.isLoadingProject ? (
                  <DropdownSkeleton />
                ) : (
                  <ComboBox
                    id="idSearchProject"
                    placeholder={this.state.searchModel.idProject ? filterItems.idProject : 'All'}
                    name="idProject"
                    alt="searchModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={this.state.searchModel.idProject ? filterItems.idProject : 'All'}
                    items={this.state.allProject}
                    // invalid={validations.pro != null}
                  />
                )}
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4">
                <FormLabel className="some-class">Hazard Type</FormLabel>
                {this.state.isLoadingHazardType ? (
                  <DropdownSkeleton />
                ) : (
                  <ComboBox
                    id="idSearchHazardType"
                    placeholder={this.state.searchModel.idHazardType ? filterItems.idHazardType : 'All'}
                    name="idHazardType"
                    alt="searchModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={this.state.searchModel.idHazardType ? filterItems.idHazardType : 'All'}
                    items={this.state.hazardtype}
                    // items={this.state.search.search}
                  />
                )}
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4">
                <FormLabel className="some-class">HocType</FormLabel>
                {this.state.isLoadingHocType ? (
                  <DropdownSkeleton />
                ) : (
                  <ComboBox
                    id="idSearchHocType"
                    placeholder={this.state.searchModel.idHocType ? filterItems.idHocType : 'All'}
                    name="idHocType"
                    alt="searchModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={this.state.searchModel.idHocType ? filterItems.idHocType : 'All'}
                    items={this.state.hoctype}
                    // items={this.state.search.search}
                  />
                )}
              </FormGroup>
              {/* <FormGroup legendText="" className="bx--col-md-4">
                             <FormLabel className="some-class">
                                Status
                                    </FormLabel>
                            {this.state.isLoadingStatus ? <DropdownSkeleton /> :
                                <ComboBox
                                    id="idStatus"
                                    placeholder="All"
                                    name="idStatus"
                                    alt="searchModel"
                                    onChange={this.handleChangeCombo}
                                    itemToString={item => (item ? item.name : '')}
                                    initialSelectedItem={filterItems.IsStatus}
                                    items={this.state.status}
                                // items={this.state.search.search}
    
                                />
                            }*
                            <FormLabel className="some-class">
                                Status
                                </FormLabel>
                            {this.state.isLoadingInfoOriginator ? <DropdownSkeleton /> :
                                <ComboBox
                                    id="isStatus"
                                    placeholder="All"
                                    name="isStatus"
                                    alt="searchModel"
                                    onChange={this.handleChangeComboStatus}
                                    itemToString={item => (item ? item : '')}
                                    initialSelectedItem={filterItems.isStatus}
                                    items={this.state.isStatus}
    
                                />
                            }
                        </FormGroup> */}
    
              <FormGroup legendText="" className="bx--col-md-4">
                <FormLabel className="some-class">HOC raised by</FormLabel>
                {this.state.isLoadingInfoOriginator ? (
                  <DropdownSkeleton />
                ) : (
                  <ComboBox
                    id="idSearchInfoOriginator"
                    placeholder={this.state.searchModel.idInfoOriginator ? filterItems.idInfoOriginator : 'All'}
                    name="idInfoOriginator"
                    alt="searchModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={this.state.searchModel.idInfoOriginator ? filterItems.idInfoOriginator : 'All'}
                    items={this.state.infooriginator}
                    // items={this.state.search.search}
                  />
                )}
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4">
                <FormLabel className="some-class">CAR Associated</FormLabel>
                <ComboBox
                  id="srcxCar"
                  key="srcxCar"
                  placeholder=""
                  name="xCar"
                  alt="searchModel"
                  onChange={this.handleChangeComboBool}
                  // itemToString={item => (item ? item: '')}
                  initialSelectedItem={filterItems.xCar}
                  items={this.state.xCar}
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                <FormLabel>HOC Code</FormLabel>
                <TextInput
                  id="hocardcode"
                  name="code"
                  value={this.state.searchModel.code || ''}
                  onChange={this.handleChangeSearch}
                  placeholder="Input HOC Code"
                  type="text"
                  labelText=""
                  className="bx--text-input some-class bx--text-input--light"
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                <FormLabel>HOC Local ID</FormLabel>
                <TextInput
                  id="hocardLocalId"
                  name="localId"
                  value={this.state.searchModel.localId || ''}
                  onChange={this.handleChangeSearch}
                  placeholder="Input HOC Local ID"
                  type="text"
                  labelText=""
                  className="bx--text-input some-class bx--text-input--light"
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                <FormLabel className="some-class">CAR Status</FormLabel>
                <ComboBox
                  id="status"
                  key="status"
                  placeholder=""
                  name="status"
                  alt="searchModel"
                  onChange={this.handleChangeComboStatus}
                  // itemToString={item => (item ? item: '')}
                  initialSelectedItem={filterItems.status}
                  items={this.state.isStatus}
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-3 bx--col-lg-3">
                <FormLabel className="some-class">HOC handled by</FormLabel>
                <ComboBox
                  id="owner"
                  key="owner"
                  placeholder="All Compilers"
                  name="owner"
                  alt="searchModel"
                  onChange={this.handleChangeComboOwner}
                  initialSelectedItem={filterItems.hocHandledByMe}
                  items={this.state.hocHandledByMeOptions}
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-3 bx--col-lg-3">
                <FormLabel className="some-class">HOC CAR assigned to</FormLabel>
                <ComboBox
                  id="ownerCar"
                  key="ownerCar"
                  placeholder="All"
                  name="ownerCar"
                  alt="searchModel"
                  onChange={this.handleChangeComboCarOwner}
                  initialSelectedItem={filterItems.hocCarAssignedToMe}
                  items={this.state.hocCarAssignedToMeOptions}
                />
              </FormGroup>
              <FormGroup legendText="" className="bx--col-lg-3 bx--col-md-3">
                <FormLabel className="some-class">Source</FormLabel>
                {this.state.isLoadingProject ? (
                  <DropdownSkeleton />
                ) : (
                  <ComboBox
                    id="idSource"
                    key="idSource"
                    placeholder="All"
                    name="idHocCardSource"
                    alt="searchModel"
                    itemToString={(item) => (item && item.name) || ''}
                    onChange={this.handleChangeHocCardSourceFilter}
                    initialSelectedItem={filterItems.idHocCardSource}
                    items={this.state.hocCardSources}
                  />
                )}
              </FormGroup>
              <FormGroup legendText="" className="bx--col-md-3 bx--col-lg-3">
                <FormLabel className="some-class">HSE Review Status</FormLabel>
                <ComboBox
                  id="completionStatus"
                  key="completionStatus"
                  placeholder="All"
                  name="completionStatus"
                  alt="searchModel"
                  onChange={this.handleChangeCompletionStatusFilter}
                  initialSelectedItem={filterItems.completionStatus}
                  items={this.completionStatusList}
                />
              </FormGroup>
            </div>
            <div>
              <div className="searchFormFooter">
                <Button className="button--max-width" kind="secondary" onClick={this.clearFilter}>
                  Cancel
                </Button>
                <Button className="button--max-width" kind="primary" onClick={this.handleClickSearch}>
                  Search
                </Button>
              </div>
            </div>
          </div>
        );
      }
      
  render() {
    // Header
    const headersHocCard = [
      { key: 'code', header: 'Code' },
      { key: 'localId', header: 'Local ID' },
      { key: 'infoOriginator', header: 'HOC raised by' }, // RITM0853708
      { key: 'hazardType', header: 'Hazard Type' },
      { key: 'project', header: 'Project' },
      { key: 'description', header: 'Description' },
      { key: 'hocType', header: 'Hoc Type' },
      { key: 'occurredAt', header: 'Date Of Occurrence ', type: 'date' },
      { key: 'status', header: 'CAR Status', type: 'status' },
      { key: 'reportBy', header: 'Reported By' },
      { key: 'isCar', header: 'CAR Associated', type: 'bool' },
      { key: 'hocCardSource', header: 'Source' },
    ];
    const validatorworksite = {
      worksite: this.validatorworksite.message('worksite', this.state.worksite.id, 'required'),
    };
    // /DELETE CONFIRM
     const confirmDelProps = () => ({
       idToDelete: this.state.idToDelete,
       nameItem: '',
       isDeleting: this.state.isDeleting,
       open: this.state.isOpenDeleteModal, // open state
       onCloseConfirm: this.onCloseConfirm, // no click
       deleteItem: this.deleteItem, // yes click fn()
     });
    // //PAGINATION
    // const paginationProps = () => ({
    //   page: this.state.currentPage || 1,
    //   totalItems: this.state.rowCount || 0,
    //   pageSize: this.state.pageSize || 10,
    //   pageSizes: [10, 20, 30, 40, 50],
    //   onChange: this.handleChangePaging,
    // });

    //RITM1110820 - HOC Slowness Issue
    const cappedPagination = ({
      maxPages,
      page,
      pageSize,
      pagesUnknown,
      totalItems,
      itemRangeText,
      pageRangeText,
      itemText,
      pageSizes
    }) => {
      const fakeTotalItems = Math.min(totalItems, maxPages * pageSize)
      const totalPages = Math.ceil(totalItems / pageSize)
    
      const itemCap = pagesUnknown ? Infinity : totalItems
      const min = Math.min(pageSize * (page - 1) + 1, itemCap)
      const max = Math.min(pageSize * page, itemCap)
    
      return (
        <Pagination
          totalItems={fakeTotalItems}
          itemRangeText={(fakeMin, fakeMax, fakeTotalItems) => itemRangeText(min, max, totalItems)}
          pageRangeText={(current, fakeTotalPages) => pageRangeText(current, totalPages)}
          itemText={(fakeMin, fakeMax) => itemText(min, max)}
          page={page}
          pageSize={pageSize}
          pagesUnknown={pagesUnknown}
         pageSizes={pageSizes}
         onChange= {this.handleChangePaging}
        />
      )
    }
    //End

		const skeletonRowCount = this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount ? this.state.rowCount : this.state.pageSize;
		return (
			<>
				<PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="HOCs" />
				<div className="mainContainer">
					<form onSubmit={this.uploadHocTemplate}>
						<ComposedModal className="light-modal" open={this.state.isOpenModalUploadTemplate} danger="false" onClose={() => false}>
							<ModalHeader className="margin-modal" buttonOnClick={() => this.toggleModalUploadTemplate(false)}>
								<p>Import HOCs</p>
							</ModalHeader>
							<ModalBody className="margin-modal">
								<div className="bx--file-container">
									<FileUploader
										ref={(node) => (this.fileUploader = node)}
										accept={[".xlsx"]}
										buttonKind="primary"
										buttonLabel="Choose a file"
										filenameStatus={this.state.statusUpload}
										iconDescription="Choose"
										labelTitle="Upload"
										labelDescription="Please, download the template file before upload new items"
										multiple={false}
										name="inputFile"
										onClick={this.clearFiles}
										onChange={this.onFileUploadChange}
									/>
								</div>
								<div>
									{this.state.isImportHC ? this.divMessaggImportHC() : ""}
									{this.state.isImportfunction ? <Loading /> : ""}
								</div>
							</ModalBody>
							<ModalFooter>
								<Button kind="secondary" onClick={() => this.toggleModalUploadTemplate(false)}>
									Cancel
								</Button>
								<Button kind="primary" type={this.state.statusUpload != null ? "submit" : "button"} onClick={this.state.statusUpload != null ? this.clearFiles : null} disabled={!this.state.statusUpload}>
									Upload
								</Button>
							</ModalFooter>
						</ComposedModal>
					</form>
					<form onSubmit={this.uploadHocEditTemplate}>
						<ComposedModal className="light-modal" open={this.state.isOpenModalUploadEditTemplate} danger="false" onClose={() => false}>
							<ModalHeader className="margin-modal" buttonOnClick={() => this.toggleModalUploadEditTemplate(false)}>
								<p>Import Edited HOCs</p>
							</ModalHeader>
							<ModalBody className="margin-modal">
								<div className="bx--file-container">
									<FileUploader
										ref={(node) => (this.fileUploader = node)}
										accept={[".xlsx"]}
										buttonKind="primary"
										buttonLabel="Choose a file"
										filenameStatus={this.state.statusUpload}
										iconDescription="Choose"
										labelTitle="Upload"
										labelDescription="Please, download the edit template file before upload new items"
										multiple={false}
										name="inputFile"
										onClick={this.clearFiles}
										onChange={this.onFileUploadChange}
									/>
								</div>
								<div>
									{this.state.isImportEditHC ? this.divMessaggImportHC() : ""}
									{this.state.isImportEditfunction ? <Loading /> : ""}
								</div>
							</ModalBody>
							<ModalFooter>
								<Button kind="secondary" onClick={() => this.toggleModalUploadEditTemplate(false)}>
									Cancel
								</Button>
								<Button kind="primary" type={this.state.statusUpload != null ? "submit" : "button"} onClick={this.state.statusUpload != null ? this.clearFiles : null} disabled={!this.state.statusUpload}>
									Upload
								</Button>
							</ModalFooter>
						</ComposedModal>
					</form>
					<ConfirmAlertCustom {...confirmDelProps()} />
					<ComposedModal className="light-modal" open={this.state.isOpenModalExportTemplate} danger="false" onClose={() => false}>
						<ModalHeader className="margin-modal" buttonOnClick={this.clearTemplate}>
							<p>Export HOC Template - Select Worksite</p>
						</ModalHeader>
						<ModalBody className="margin-modal">
							<div>
								<Form className="bx--grid--full-width">
									<div className="bx--row">
										<FormGroup legendText="" className=" bx--col--md-12 bx--col-lg-12">
											<FormLabel>Worksite*</FormLabel>
											{this.state.isLoadingWorksite ? (
												<DropdownSkeleton />
											) : (
												<Select
													id="idWorkSite"
													name="idWorkSite"
													className="max-width"
													value={this.state.worksite.id || ""}
													light
													inline={false}
													hideLabel
													invalid={validatorworksite.worksite != null}
													onChange={this.handleChangeWorksite}
												>
													<SelectItem value="" text="" />
													{this.state.worksites.map(({ id, name }, i) => (
														<SelectItem key={i} value={id} text={name} />
													))}
												</Select>
											)}
											{validatorworksite.worksite}
										</FormGroup>
										{!this.state.isExportfunction ? "" : <Loading />}
									</div>
								</Form>
							</div>
						</ModalBody>
						<ModalFooter>
							<Button kind="secondary" onClick={this.clearTemplate}>
								Cancel
							</Button>
							<Online>
								<FileDownLoadButton
									onError={(error) => {
										showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.DOWNLOAD));
									}}
									onDownLoadStart={() => this.setState({ isExportfunction: true })}
									onDownLoadEnd={() => this.setState({ isExportfunction: false })}
									apiUrl={`/hoccard/template/${this.state.worksite.id}`}
									fileName="HocCardTemplate.xlsx"
									kind="primary"
								>
									Export
								</FileDownLoadButton>
							</Online>
						</ModalFooter>
					</ComposedModal>

					<div className="bx--grid content full-width mainContainer ">
						<div className="bx--row">
							<div className="bx--col-lg-12 bx--tab-container">
							<div className="bx--row">
										<h4 className="description-page">
											Current year
											<Dropdown
												id="ddYear"
												items={this.state.yearsList}
												onChange={this.onYearChange}
												initialSelectedItem={this.year.toString()}
												selectedItem={this.state.filteredYear? this.state.filteredYear.toString() : this.year.toString()}
												itemToString={(item) => item || ""}
												type="inline"
												label=""
											/>
									</h4>
								</div>
								<div className="content-modal">
									<div className="hocToolbar">
									<TableToolbar>
											<div className="hocToolbarContainer-nocolor">
												<span>&nbsp;</span>
												<div className="hocToolbarInternalContainer">
													<Search readOnly light className="search cursor-pointer hiddenSearch" labelText="Search" placeHolderText="Search" id="search-1" onClick={this.showDivFilter} />
													<Button onClick={this.showDivFilter} className="buttonPaddingIcon" renderIcon={Data16} iconDescription="filter" />
												</div>
											</div>
											<div className="hocToolbarContainer">
												<span>Create new HOCs</span>
												<div className="hocToolbarInternalContainer">
													<Button renderIcon={Add16} onClick={this.showNewHocCard}>
														Create New
													</Button>
													<Online>
														<Button renderIcon={Export16} onClick={() => this.toggleModalUploadTemplate(true)}>
															Import HOCs
														</Button>
														<Button renderIcon={Import16} onClick={() => this.toggleModalExportTemplate(true)}>
															Download Template
														</Button>
													</Online>
												</div>
											</div>
											<div className="hocToolbarContainer">
												<span>Managing HOCs</span>
												<div className="hocToolbarInternalContainer">
													<Online>
														<Button renderIcon={Export16} onClick={() => this.toggleModalUploadEditTemplate(true)}>
															Import Edited HOCs
														</Button>

														<Button renderIcon={Import16} onClick={() => this.getTemplateExcelForEdit()}>
															{!this.state.isExportfunction ? "Download HOCs" : <InlineLoading />}
														</Button>
													</Online>
												</div>
											</div>
									</TableToolbar>
									</div>
									{!this.state.isOpenFilterHoc ? "" : this.divFiterHocCard()}
									<DataTable
										rows={this.state.itemList || []}
										headers={headersHocCard}
										useZebraStyles
										size="compact"
										render={({ rows, headers, getHeaderProps, getRowProps }) => (
											<TableContainer className="bx--grid--full-width">
												{this.state.isLoadingList ? (
													<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
												) : (
													<Table className="">
														<TableHead className="colorgray">
															<TableRow>
																{headers.map((header) => (
																	<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																		{header.header}
																	</TableHeader>
																))}
																<TableHeader className="align-center">Actions</TableHeader>
															</TableRow>
														</TableHead>
														<TableBody>
															{rows == null || rows.length == 0 ? (
																<NoRecordsPlaceholder colSpan={headers.length + 1} />
															) : (
																rows.map((row) => (
																	<TableRow {...getRowProps({ row })}>
																		{row.cells.map((cell) => (
																			<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																		))}

                                    <TableCell key={`action-${row.id}`} className="tableActions align-center">
                                      <div>
                                        <Link to={`/hoccard/${row.id}`}>
                                          <Button size="small" renderIcon={Edit16} iconDescription="Folder" kind="ghost" />
                                        </Link>
                                        <Online>
                                          <Button
                                            onClick={() => this.confirmDelete(row.id)}
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            kind="ghost"
                                          />
                                        </Online>
                                        <Offline>
                                          <Button size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" disabled />
                                        </Offline>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))
                              )}
                            </TableBody>
                          </Table>
                        )}
                      </TableContainer>
                    )}
                  />

                  <div className="footer-pagination">
                    {/* RITM1110820 - HOC Slowness Issue */}
                      {cappedPagination({maxPages: 5000, page: this.state.currentPage || 1, pageSize: this.state.pageSize || 100, pagesUnknown: false, totalItems: this.state.rowCount || 0, 
                        itemRangeText: function itemRangeText(min, max, total) {
                        return "".concat(min, "\u2013").concat(max, " of ").concat(total, " items");
                      },
                        pageRangeText: function pageRangeText(current, total) {
                        return "of ".concat(total, " pages");
                      }, 
                      itemText: function itemText(min, max) {
                        return "".concat(min, "\u2013").concat(max, " items");
                      },
                      pageSizes: [300, 600, 900, 1200, 1500] })} 
                    {/* End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

HocCard.contextType = AppContext;
HocCard.propTypes = {
    location: PropTypes.shape({
      hash: PropTypes.string,
      key: PropTypes.string,
      pathname: PropTypes.string,
      search: PropTypes.string,
    }).isRequired,
  };
